import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

const pageWrapper = {
  minHeight: "100vh",
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  padding: "60px 24px",
  background: "#f5f5f5",
};

const cardStyle = {
  background: "#fff",
  borderRadius: 14,
  padding: "28px 26px",
  width: "90vw",
  maxWidth: 480,
  boxShadow: "0 12px 40px rgba(0,0,0,0.12)",
};

const titleStyle = {
  fontSize: 20,
  fontWeight: 700,
  marginBottom: 6,
  color: "#111",
  textAlign: "center",
};

const descriptionStyle = {
  fontSize: 13,
  color: "#666",
  marginBottom: 22,
  lineHeight: 1.5,
  textAlign: "center",
};

const labelStyle = {
  fontSize: 12,
  fontWeight: 600,
  color: "#555",
  display: "block",
  marginBottom: 6,
};

const inputStyle = {
  width: "100%",
  padding: 12,
  borderRadius: 8,
  border: "1px solid #ccc",
  boxSizing: "border-box",
  marginBottom: 16,
  fontSize: 14,
};

const textareaStyle = {
  ...inputStyle,
  minHeight: 140,
  resize: "vertical",
  fontFamily: "inherit",
};

const primaryButton = {
  width: "100%",
  padding: 13,
  borderRadius: 8,
  background: "#00bfff",
  border: "none",
  color: "#fff",
  fontWeight: 700,
  fontSize: 14,
  cursor: "pointer",
};

const alertStyle = (isError) => ({
  fontSize: 13,
  marginBottom: 16,
  padding: "8px 10px",
  borderRadius: 6,
  background: isError ? "rgba(220,20,60,0.08)" : "rgba(0,135,79,0.08)",
  color: isError ? "crimson" : "#00874f",
});

export default function Support() {
  const navigate = useNavigate();
  const username = localStorage.getItem("spectraUser");

  const [description, setDescription] = useState("");
  const [replyToEmail, setReplyToEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [supportId, setSupportId] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!description.trim()) {
      setError("Please describe your issue before submitting.");
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("spectraToken") || "";
      const res = await fetch(`${API_URL}/api/support`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ description, replyToEmail }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Could not send your support request.");
        return;
      }
      setSupportId(data.supportId);
    } catch (err) {
      console.error(err);
      setError("Could not reach the server. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (supportId) {
    return (
      <div style={pageWrapper}>
        <div style={cardStyle}>
          <div style={titleStyle}>Request Submitted</div>
          <div style={descriptionStyle}>
            One of our support members will reach out to you regarding your support issue or concern as
            soon as we can. Thank you for your patience.
          </div>
          <div style={{ ...alertStyle(false), textAlign: "center", fontWeight: 700 }}>
            Support ID: {supportId}
          </div>
          <button type="button" style={primaryButton} onClick={() => navigate("/settings")}>
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={pageWrapper}>
      <div style={cardStyle}>
        <div style={titleStyle}>Contact &amp; Support</div>
        <div style={descriptionStyle}>
          Describe the issue you're having and our support team will follow up by email.
        </div>

        {error && <div style={alertStyle(true)}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <label style={labelStyle}>Username</label>
          <input value={username || ""} disabled style={{ ...inputStyle, background: "#f5f5f5", color: "#888" }} />

          <label style={labelStyle}>Your email (optional, so we can reply)</label>
          <input
            type="email"
            value={replyToEmail}
            onChange={(e) => setReplyToEmail(e.target.value)}
            style={inputStyle}
            placeholder="you@example.com"
          />

          <label style={labelStyle}>Describe your issue</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={textareaStyle}
            placeholder="Tell us what's going on..."
            autoFocus
          />

          <button type="submit" style={primaryButton} disabled={loading}>
            {loading ? "Sending..." : "Submit Support Request"}
          </button>
        </form>
      </div>
    </div>
  );
}
